import { render, staticRenderFns } from "./ComplainListToolbar.vue?vue&type=template&id=342bb7f2&"
import script from "./ComplainListToolbar.vue?vue&type=script&lang=js&"
export * from "./ComplainListToolbar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports